<rt-button
  [variant]="isPlain ? 'plain' : 'outline'"
  #statusDropdownTrigger="rtOverlayOrigin"
  (click)="openStatusDropdown(statusDropdown)"
  [dropdownVisible]="!isPlain"
  [dropdownOpened]="statusDropdown.open"
  rt-overlay-origin
  [class.pointer-events-none]="state !== 'default'"
  margin-left-small-x
>
  <rt-offer-status [status]="offer.status" [offerStatus]="offer.status"> </rt-offer-status>
</rt-button>

<ng-template
  (backdropClick)="statusDropdown.open = false"
  [origin]="statusDropdownTrigger"
  #statusDropdown="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown class="statuses-dropdown" [width]="DropdownWidth.Medium">
    <rt-dropdown-header (click)="$event.preventDefault()">
      {{ 'app.offers.offer_status' | translate }}
    </rt-dropdown-header>
    @if (hasPublishActions) {
      <rt-dropdown-item
        [isSelected]="offer.status === OfferStatus.Published"
        (click)="changeStatus(StatusChangeType.Publish)"
      >
        <rt-offer-status status="published" [offerStatus]="offer.status"> </rt-offer-status>
      </rt-dropdown-item>
    }
    @if (hasPublishActions) {
      <rt-dropdown-item
        [isSelected]="offer.status === OfferStatus.Internal"
        (click)="changeStatus(StatusChangeType.Unpublish)"
      >
        <rt-offer-status status="internal" [offerStatus]="offer.status"> </rt-offer-status>
      </rt-dropdown-item>
    }
    <rt-dropdown-item
      [isSelected]="offer.status === OfferStatus.Closed"
      (click)="changeStatus(StatusChangeType.Close)"
    >
      <rt-offer-status status="closed" [offerStatus]="offer.status"> </rt-offer-status>
    </rt-dropdown-item>
    <rt-dropdown-item
      [isSelected]="offer.status === OfferStatus.Archived"
      (click)="changeStatus(StatusChangeType.Archive)"
    >
      <rt-offer-status status="archived" [offerStatus]="offer.status"> </rt-offer-status>
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
